module.exports = __webpack_public_path__ + "media/bootstrap-icons/pie-chart-f1c34ea5.svg";